/* eslint-disable @typescript-eslint/no-explicit-any */
import { Col, Form, Input, Row } from 'antd';
import { ColProps } from 'antd/lib/col';
import { Rule } from 'antd/lib/form';
import { NamePath } from 'antd/lib/form/interface';
import { InputProps } from 'antd/lib/input';
import { default as React, useContext, useEffect, useRef, useState } from 'react';

import Paragraph from 'components/atoms/Paragraph';
import SelectComponent from 'components/atoms/SelectComponent';
import { Context } from 'components/hoc/Store';
import TranslateText from 'components/hoc/TranslateText';

import getLanguageObject from 'utils/getLanguageObject';
import { phoneValidationNoCountryCode } from 'utils/validations/phoneValidation';

import InfoTooltip from './InfoTooltip';

interface IPhoneNumberInput extends InputProps {
    label?: string;
    labelAlign?: 'left' | 'right';
    name: string;
    className?: string;
    initialValue?: string | number;
    rules?: Rule[]; // Pro ted disabled nevime co vse budeme potrebovat a jak to budeme zapisovat
    dependencies?: NamePath[]; // pouzit napr pri validacii 2 poli ktore suvisia = heslo / heslo overeni
    extramessage?: string;
    /** Urcuje sirku labelu */
    labelCol?: ColProps;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onBlur?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    infoTooltipText?: string;
    notRequired?: boolean;
    validateTrigger?: string | string[];
    hide?: boolean; // ak nechceme zobrazit komponentu ale ponechat jej value
    validateStatus?: '' | 'success' | 'warning' | 'error' | 'validating' | undefined;
    disableEdit?: boolean;
    disabled?: boolean;
    maxLength?: number;
}

const predcisliSelect = [
    {
        labelcz: '+420',
        value: '+420'
    },
    {
        labelcz: '+421',
        value: '+421'
    }
];

const { Item } = Form;

const PhoneNumberInput: React.FC<IPhoneNumberInput> = props => {
    const { language } = useContext(Context);
    const {
        label,
        labelAlign,
        name,
        className = '',
        initialValue,
        dependencies = [],
        rules = phoneValidationNoCountryCode(),
        notRequired,
        extramessage = '',
        labelCol,
        validateTrigger = 'onClick',
        validateStatus,
        onChange,
        onBlur,
        hide,
        infoTooltipText = '',
        disableEdit,
        disabled,
        maxLength,
        ...rest
    } = props;

    const predvolbaInitVal = predcisliSelect.filter(e => String(initialValue)?.startsWith(String(e.value)));
    const [predvolbaVal, setPredvolbaVal] = useState<string>(
        initialValue && predvolbaInitVal.length ? predvolbaInitVal[0].value : '+420'
    );
    const [cisloVal, setCisloVal] = useState<string | number | undefined>(
        predvolbaInitVal.length
            ? String(initialValue || '').slice(predvolbaInitVal[0].value.length)
            : maxLength && String(initialValue).length > maxLength
              ? String(initialValue).slice(0, maxLength)
              : initialValue
    );

    const inputNumberRef = useRef<any>(null);
    const isFirstRender = useRef<boolean>(true);

    useEffect(() => {
        if (!isFirstRender.current) {
            const numFormInput = inputNumberRef.current.nativeElement;
            const newEv = new MouseEvent('click', {
                view: window,
                bubbles: true,
                cancelable: true
            });
            numFormInput.dispatchEvent(newEv);
        } else {
            isFirstRender.current = false;
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [predvolbaVal, cisloVal]);

    return (
        <Item
            label={
                label ? (
                    <>
                        <Paragraph text={label} strong={true} disableEdit={disableEdit} />{' '}
                        {infoTooltipText && <InfoTooltip title={infoTooltipText} />}{' '}
                    </>
                ) : null
            }
            hidden={hide}
            labelAlign={labelAlign}
            className={className}
            name={name}
            initialValue={initialValue}
            normalize={() => {
                return predvolbaVal + cisloVal;
            }}
            dependencies={dependencies}
            trigger={'onClick'}
            shouldUpdate={() => true}
            rules={
                notRequired
                    ? rules
                    : [
                          {
                              required: true,
                              message: <TranslateText>NEVALIDNI_POVINNA_POLOZKA</TranslateText>
                          },
                          () => ({
                              validator() {
                                  if (predvolbaVal) return Promise.resolve();
                                  return Promise.reject(<TranslateText>PREDVOLBA_VAL_ERR</TranslateText>);
                              }
                          }),
                          ...rules
                      ]
            }
            extra={<Paragraph text={extramessage} className="extramessage-text" />}
            labelCol={labelCol}
            validateTrigger={validateTrigger}
            validateStatus={validateStatus}
        >
            <Row
                style={{
                    width: '100%'
                }}
            >
                <Col
                    style={{
                        maxWidth: 105
                    }}
                    span={4}
                >
                    <SelectComponent
                        data={predcisliSelect}
                        // name={'predcisli'}
                        placeholder=""
                        onChange={val => {
                            setPredvolbaVal(val);
                            onChange && onChange(val);
                        }}
                        defaultValue={predvolbaVal}
                        disabled={disabled}
                    />
                </Col>
                <Col
                    style={{
                        flexGrow: 1
                    }}
                >
                    <Input
                        type="tel"
                        placeholder={disabled ? '' : getLanguageObject(language).VYPLNTE_PLACEHOLDER || 'Vyplňte...'}
                        className="input-component"
                        onChange={ev => {
                            setCisloVal(ev.target.value);
                            onChange && onChange(ev);
                        }}
                        onBlur={onBlur}
                        ref={inputNumberRef}
                        disabled={disabled}
                        defaultValue={cisloVal}
                        {...rest}
                    />
                </Col>
            </Row>
        </Item>
    );
};
export default PhoneNumberInput;

93;
355;
213;
684;
376;
244;
54;
374;
297;
247;
61;
994;
973;
880;
32;
501;
375;
229;
975;
591;
387;
267;
55;
673;
359;
226;
257;
682;
235;
382;
420;
86;
45;
243;
246;
253;
20;
593;
291;
372;
251;
298;
500;
679;
63;
358;
33;
594;
689;
241;
220;
233;
350;
299;
995;
590;
502;
224;
245;
592;
509;
504;
852;
56;
385;
91;
62;
964;
98;
353;
354;
39;
972;
1876;
81;
967;
27;
962;
855;
237;
1;
238;
974;
7;
254;
686;
57;
269;
242;
850;
82;
37744;
37745;
3777;
506;
53;
965;
357;
996;
856;
266;
961;
231;
218;
423;
370;
371;
352;
853;
261;
36;
389;
60;
265;
960;
223;
356;
212;
692;
596;
230;
222;
269;
52;
691;
373;
377;
976;
258;
95;
264;
674;
49;
977;
227;
234;
505;
683;
599;
31;
672;
47;
687;
64;
968;
92;
680;
970;
507;
675;
595;
51;
225;
48;
351;
43;
262;
240;
40;
7;
250;
30;
503;
378;
966;
221;
248;
232;
65;
421;
386;
252;
971;
381;
94;
236;
249;
597;
290;
508;
239;
268;
963;
677;
34;
46;
41;
992;
886;
255;
66;
228;
690;
676;
216;
90;
993;
688;
256;
380;
598;
1;
998;
678;
44;
58;
84;
670;
681;
260;
685;
263;
